module.exports = __webpack_public_path__ + "media/images/icon-add-outline-e47ed7571912ee59c6d26d4e05fd67e0.svg";